import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { RouteService } from 'src/app/services/route.service';
import { ProjectsFinanceIncomeComponent } from '../projects-finance-income/projects-finance-income.component';
import { ProjectsFinanceInstalmentFormComponent } from '../projects-finance-instalment-form/projects-finance-instalment-form.component';
import { ProjectsFinanceAnalysisComponent } from '../projects-finance-analysis/projects-finance-analysis.component';
import { ProjectsFinanceTestingCostFormComponent } from '../projects-finance-testing-cost-form/projects-finance-testing-cost-form.component';
import { ProjectsFinanceOtherCostFormComponent } from '../projects-finance-other-cost-form/projects-finance-other-cost-form.component';

export type ProjectsFinanceView =
  | 'income'
  | 'analysis'
  | 'instalment-edit'
  | 'testing-cost-form'
  | 'other-cost-form';

@Component({
  selector: 'projects-finance',
  imports: [
    ProjectsFinanceIncomeComponent,
    ProjectsFinanceInstalmentFormComponent,
    ProjectsFinanceAnalysisComponent,
    ProjectsFinanceTestingCostFormComponent,
    ProjectsFinanceOtherCostFormComponent
  ],
  templateUrl: './projects-finance.component.html',
  styleUrl: './projects-finance.component.scss'
})
export class ProjectsFinanceComponent implements OnInit {
  @Input() projectId?: string;
  @Input() initialView: ProjectsFinanceView = 'income';
  @Input() syncUrl: boolean = false;

  view: ProjectsFinanceView = 'income';
  entityId: number | null = null;

  readonly financeTabs: { id: 'income' | 'analysis'; title: string }[] = [
    { id: 'income', title: 'Income' },
    { id: 'analysis', title: 'Analysis' }
  ];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private routeService: RouteService
  ) { }

  ngOnInit(): void {
    const snapshot = this.route.snapshot;
    this.view = this.initialView;

    const entityParam = snapshot.paramMap.get('projectInvoiceId')
      ?? snapshot.paramMap.get('projectFinanceCostId')
      ?? snapshot.paramMap.get('projectFinanceOtherCostId');
    this.entityId = entityParam ? Number(entityParam) : null;
  }

  get isListView(): boolean {
    return this.view === 'income' || this.view === 'analysis';
  }

  get projectIdNumber(): number {
    return Number(this.projectId);
  }

  selectTab(tabId: 'income' | 'analysis'): void {
    this.view = tabId;
    if (this.syncUrl && this.projectId) {
      this.location.replaceState(tabId === 'income'
        ? this.routeService.projectsFinanceIncomeUrl(this.projectIdNumber)
        : this.routeService.projectsFinanceAnalysisUrl(this.projectIdNumber));
    }
  }
}
